import type { AnimationConfig } from '../../Animate.types'

const getMaximumDuration = (animationCfg: AnimationConfig): number => {
  const maxDuration = animationCfg.duration || 0
  const maxDelay = animationCfg.delay || 0
  return maxDuration + maxDelay
}

export default getMaximumDuration
